import { useEffect, useState } from "react";
import { Loader2, Pencil, Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGold, errMsg, inp } from "@/components/attendance/ui";

export default function Denominations({ onChanged }) {
  const [rows, setRows] = useState(null);
  const [f, setF] = useState({ code: "", name: "" });
  const load = () => api.get("/admin/projection/denominations").then((r) => { setRows(r.data); onChanged?.(); }).catch(() => toast.error("Could not load denominations"));
  useEffect(() => { load(); }, []);
  const act = async (fn, ok) => { try { await fn(); toast.success(ok); load(); return true; } catch (e) { toast.error(errMsg(e, "Action failed")); return false; } };

  const add = async (e) => { e.preventDefault(); if (await act(() => api.post("/admin/projection/denominations", f), "Denomination added")) setF({ code: "", name: "" }); };
  const rename = (d) => { const name = window.prompt("Denomination name", d.name); if (name) act(() => api.put(`/admin/projection/denominations/${d.id}`, { code: d.code, name }), "Saved"); };
  const addEdition = (d) => { const name = window.prompt(`New hymnbook edition for ${d.name}`); if (name) act(() => api.post(`/admin/projection/denominations/${d.id}/editions`, { name }), "Edition added"); };

  if (!rows) return <Loader2 className="animate-spin text-[#D4AF37]" />;
  return (
    <section className="space-y-4" data-testid="denominations-admin">
      <form onSubmit={add} className="flex flex-wrap gap-2">
        <input className={`${inp} !w-32`} placeholder="Code e.g. METH" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} data-testid="denom-code" required />
        <input className={`${inp} max-w-sm`} placeholder="Name e.g. Methodist Church" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="denom-name" required />
        <button className={btnGold} data-testid="denom-add"><Plus size={14} /> Add denomination</button>
      </form>
      <div className="space-y-2">
        {rows.map((d) => (
          <div key={d.id} className="luxury-card rounded-lg p-4" data-testid={`denom-${d.code}`}>
            <div className="flex flex-wrap items-center gap-3">
              <span className="font-serif-display text-xl text-[#D4AF37] w-20">{d.code}</span>
              <span className="text-white flex-1">{d.name}{d.is_default && <span className="ml-2 text-[10px] tracking-widest uppercase text-emerald-300">Default · master numbering</span>}</span>
              <span className="text-xs text-neutral-500">{d.mapping_count} mappings</span>
              <button onClick={() => rename(d)} title="Rename" className="p-2 text-neutral-400 hover:text-[#D4AF37]" data-testid={`denom-rename-${d.code}`}><Pencil size={14} /></button>
              {!d.is_default && <button onClick={() => addEdition(d)} title="Add edition" className="p-2 text-neutral-400 hover:text-[#D4AF37]" data-testid={`denom-add-edition-${d.code}`}><Plus size={14} /></button>}
              {!d.is_default && <button onClick={() => window.confirm(`Delete ${d.name}?`) && act(() => api.delete(`/admin/projection/denominations/${d.id}`), "Deleted")} title="Delete" className="p-2 text-neutral-400 hover:text-red-400" data-testid={`denom-delete-${d.code}`}><Trash2 size={14} /></button>}
            </div>
            {d.editions?.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-2 pl-20">
                {d.editions.map((e) => (
                  <span key={e.id} className="text-xs border border-white/15 rounded px-2 py-1 text-neutral-300 inline-flex items-center gap-1">{e.name}
                    <button onClick={() => act(() => api.delete(`/admin/projection/denominations/${d.id}/editions/${e.id}`), "Edition removed")} className="hover:text-red-400" title="Remove edition"><X size={11} /></button>
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
